import { useEffect, useState } from "react";
import { fetchFoundingOffer, type FoundingOffer } from "@/lib/pricing/foundingOffer";

let pending: Promise<FoundingOffer> | null = null;

/**
 * The ZAKLADATEL offer, read once per page load after mount (never during
 * render, so the prerendered landing has no offer in its markup).
 */
export function useFoundingOffer(): FoundingOffer | null {
  const [offer, setOffer] = useState<FoundingOffer | null>(null);
  useEffect(() => {
    let alive = true;
    pending ??= fetchFoundingOffer();
    void pending.then((o) => alive && setOffer(o));
    return () => {
      alive = false;
    };
  }, []);
  return offer;
}
